import { importWithReload } from '@/lib/lazyWithReload'

let bookPagePromise

export function prefetchBookPage() {
  bookPagePromise ||= importWithReload(() => import('@/pages/BookPage'))
  return bookPagePromise
}
